// extracted by mini-css-extract-plugin
module.exports = {"error":"_2uU0QxJyUMRQu5Ku6yhdS0"};